import { Button, ButtonGroup } from "@msuite/ui/button";
import { useTranslation } from "@msuite/ui/localization";
import { ConfirmModal, useAsyncModal } from "@msuite/ui/modal";
import type { ProtocolFormSchema } from "@msuite/utils/schemas";
import React from "react";
import { useFormContext, useFormState } from "react-hook-form";
import { useNavigate } from "react-router";

export function ProtocolFormFooter() {
	/** Context */
	const methods = useFormContext<ProtocolFormSchema>();
	const { isDirty } = useFormState({ control: methods.control });

	/** Hooks */
	const { t } = useTranslation();
	const asyncModal = useAsyncModal();
	const navigate = useNavigate();

	/** Functions */
	async function handleOnCancel() {
		if (isDirty) {
			const isConfirmed = await asyncModal.confirm();
			if (!isConfirmed) return;
		}
		navigate(-1);
	}

	/** Render */
	return (
		<React.Fragment>
			<div
				className="grid h-full"
				style={{
					gridTemplateRows: "1fr max-content",
				}}
			>
				<div />
				<ButtonGroup
					isAttached={false}
					className="justify-end"
				>
					<Button
						variant="ghost"
						onClick={handleOnCancel}
					>
						{t("general.cancel")}
					</Button>
					<Button
						variant="primary"
						type="submit"
						isLoading={methods.formState.isSubmitting}
					>
						{t("general.done")}
					</Button>
				</ButtonGroup>
			</div>
			<ConfirmModal
				controller={asyncModal}
				message={t("protocols.are_you_sure_you_want_to_dismiss_this_protocol")}
			/>
		</React.Fragment>
	);
}
